import { render, staticRenderFns } from "./Bgg_Rating.vue?vue&type=template&id=e8864040&scoped=true"
import script from "./Bgg_Rating.vue?vue&type=script&lang=js"
export * from "./Bgg_Rating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8864040",
  null
  
)

export default component.exports